import { render, staticRenderFns } from "./RoomStatus.vue?vue&type=template&id=7249c79c&scoped=true"
import script from "./RoomStatus.vue?vue&type=script&lang=js"
export * from "./RoomStatus.vue?vue&type=script&lang=js"
import style0 from "./RoomStatus.vue?vue&type=style&index=0&id=7249c79c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7249c79c",
  null
  
)

export default component.exports